
import React from "react";
import { useCommunityProfiles } from "@/hooks/useCommunityProfiles";
import ProfileCard from "@/components/community/ProfileCard";
import ProfileFilters from "@/components/community/ProfileFilters";
import { Loader2, Users, ArrowLeft } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Link } from "react-router-dom";

const CommunityPage: React.FC = () => {
  const { 
    profiles, 
    isLoading, 
    filters, 
    setFilters,
    filterOptions
  } = useCommunityProfiles();
  
  return (
    <div className="container py-8">
      <div className="flex items-center gap-2 mb-2">
        <Button variant="ghost" size="sm" asChild className="mr-2">
          <Link to="/dashboard">
            <ArrowLeft className="h-4 w-4 mr-1" />
            Back to Dashboard
          </Link>
        </Button>
      </div>
      
      <div className="flex items-center gap-2 mb-6">
        <Users className="h-6 w-6" />
        <h1 className="text-2xl font-bold">Community</h1>
      </div>
      
      <ProfileFilters 
        filters={filters}
        setFilters={setFilters}
        filterOptions={filterOptions}
      />
      
      {isLoading ? (
        <div className="flex justify-center items-center min-h-[300px]">
          <Loader2 className="h-8 w-8 animate-spin text-muted-foreground" />
        </div>
      ) : profiles.length === 0 ? (
        <div className="text-center py-12 border rounded-lg bg-card">
          <Users className="h-12 w-12 mx-auto text-muted-foreground mb-4" />
          <h2 className="text-xl font-medium mb-2">No users found</h2>
          <p className="text-muted-foreground max-w-md mx-auto">
            {filters.searchTerm || filters.country || filters.university || filters.expertise ? 
              "Try adjusting your filters to see more results." :
              "There are no users in the community yet."}
          </p>
        </div>
      ) : (
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {profiles.map((profile) => (
            <ProfileCard key={profile.id} profile={profile} />
          ))}
        </div>
      )}
    </div>
  );
};

export default CommunityPage;
